import { ReactNode } from 'react'

export enum StatisticType {
	green = 'green',
	orange = 'orange',
	blue = 'blue',
	grey = 'grey',
	red = 'red',
	lightGrey = 'lightGrey',
	purple = 'purple'
}

export interface DefaultStatistic {
	title: string
	type: StatisticType
	shouldBeFiltered?: boolean
}

export interface Statistic extends DefaultStatistic {
	value: ReactNode
}

export interface Props {
	data: Statistic[]
	isLoading: boolean
	className?: string
}
